import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_TableView = _resolveComponent("TableView", true)!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-3 px-7" }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_skeleton_loader, { type: "table-thead" }),
            _createVNode(_component_v_skeleton_loader, { type: "table-row-divider" }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPerPage, (n) => {
              return (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: n,
                type: "table-row-divider"
              }))
            }), 128)),
            _createVNode(_component_v_skeleton_loader, { type: "table-tfoot" })
          ]))
        : (_openBlock(), _createBlock(_component_v_data_table_server, {
            key: 1,
            headers: _ctx.headers,
            items: _ctx.data,
            loading: _ctx.loading,
            "sort-by": [{ key: _ctx.sort, order: _ctx.order }],
            "hide-default-footer": true,
            "show-expand": _ctx.hasExpand,
            "item-value": "id",
            "onUpdate:options": _ctx.onUpdateOptions,
            hover: ""
          }, _createSlots({
            "item.actions": _withCtx(({ item }) => [
              _createVNode(_component_v_menu, null, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, { variant: "text" }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("mdi-dots-horizontal")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        onClick: ($event: any) => (_ctx.editItem(item))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode("Editar")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_v_list_item, {
                        onClick: ($event: any) => (_ctx.deleteItem(item))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("Eliminar")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            [`item.user`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item?.attributes
            ? item?.attributes?.user?.name + (item?.attributes?.user?.last_name ? ' ' + item?.attributes?.user?.last_name : '')
            : item?.user?.name + (item?.user?.last_name ? ' ' + item?.user?.last_name : '')), 1)
            ]),
            [`item.client`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item.client?.attributes?.commercial_name || item.client?.attributes?.legal_name), 1)
            ]),
            [`item.contact`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item?.contact!=null?(item?.contact?.name + (item?.contact?.last!=null?(' ' + item?.contact?.last):'')):''), 1)
            ]),
            [`item.subject`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item?.subject?.attributes?.commercial_name || item?.subject?.attributes?.legal_name || item?.subject?.attributes?.name || ''), 1)
            ]),
            [`item.product`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item?.description) + " ", 1),
              (_ctx.getOrganizationName(item))
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    label: "",
                    size: "x-small",
                    class: "ml-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getOrganizationName(item)), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            [`item.attributes.client_type`]: _withCtx(({ item }) => [
              _createTextVNode(_toDisplayString(item?.attributes?.client_type?.name), 1)
            ]),
            [`item.attributes.agencies`]: _withCtx(({ item }) => [
              _createVNode(_component_v_chip_group, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.attributes?.agencies, (agency, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      size: "small",
                      label: "",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(agency?.commercial_name || agency?.legal_name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            [`item.needs_authorization`]: _withCtx(({ item }) => [
              (item?.needs_authorization)
                ? (_openBlock(), _createBlock(_component_v_chip, {
                    key: 0,
                    size: "x-small",
                    color: "orange",
                    label: ""
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Requiere Autorización")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            [`item.attributes.accounts`]: _withCtx(({ item }) => [
              _createVNode(_component_v_chip_group, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.attributes?.accounts, (account, index) => {
                    return (_openBlock(), _createBlock(_component_v_chip, {
                      size: "small",
                      label: "",
                      key: index
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(account?.commercial_name || account?.legal_name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, [
            _renderList(_ctx.headers.filter(h => h.format === 'currency'), (header) => {
              return {
                name: `item.${header.value}`,
                fn: _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(_ctx.$toCurrency(item[header.value])), 1)
                ])
              }
            }),
            _renderList(_ctx.headers.filter(h => h.format === 'percentage'), (header) => {
              return {
                name: `item.${header.value}`,
                fn: _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(Number(item[header.value]).toLocaleString('es-MX') + '%'), 1)
                ])
              }
            }),
            _renderList(_ctx.headers.filter(h => h.format === 'decimal'), (header) => {
              return {
                name: `item.${header.value}`,
                fn: _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(Number(item[header.value]).toLocaleString('es-MX')), 1)
                ])
              }
            }),
            (_ctx.hasExpand)
              ? {
                  name: "expanded-row",
                  fn: _withCtx(({ columns, item }) => [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: columns.length,
                        class: "py-2"
                      }, [
                        _createVNode(_component_TableView, {
                          headers: _ctx.expandHeaders,
                          data: item[_ctx.expandKey]
                        }, null, 8, ["headers", "data"])
                      ], 8, _hoisted_2)
                    ])
                  ]),
                  key: "0"
                }
              : undefined,
            (_ctx.hasDetail)
              ? {
                  name: `item.eye_detail`,
                  fn: _withCtx(({ item }) => [
                    _createVNode(_component_v_btn, {
                      icon: "",
                      class: "elevation-0",
                      size: "small",
                      onClick: ($event: any) => (_ctx.$emit('viewItem', item.id))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                            _createTextVNode(" mdi-eye ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1032, ["headers", "items", "loading", "sort-by", "show-expand", "onUpdate:options"]))
    ]),
    _: 1
  }))
}